import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ClientActivitiesService {
  private _isDevileryWithPin: boolean = true;
  private _showFormParcelData: boolean = false;
  private _parcelCode: string = '';

  setIsDeliveryWithPin(isDevileryWithPin: boolean){
    this._isDevileryWithPin = isDevileryWithPin;
  }
  get isDevileryWithPin(): boolean{
    return this._isDevileryWithPin;
  }

  setShowFormParcelData(showForm: boolean){
    this._showFormParcelData = showForm;
  }
  get showFormParcelData(): boolean{
    return this._showFormParcelData;
  }

  setParcelCode(code: string){
    this._parcelCode = code;
  }
  get parcelCode(): string{
    return this._parcelCode;
  }
}
